import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { Header } from "@components/site/Header"

export default defineView("single-leadership", (props) => {
  const blocks = props.leadership?.contentBlocks || []

  return (
    <div className="w-full bg-slate200">
      <Header noPattern barClassName="!bg-slate200" />
      <div className="relative w-full -mb-blockSpace">
        <div className="content-sized">
          <ContentBlocks blocks={blocks} />
          {blocks.length === 1 && (
            <div className="w-full my-blockSpace" dangerouslySetInnerHTML={{ __html: "&nbsp;" }} />
          )}
        </div>
      </div>
    </div>
  )
})
